var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-activation-privilege-terms"},_vm._l((_vm.brandConsents.consents),function(term){return _c('div',{key:term.text,staticClass:"info-box"},[_c('span',{domProps:{"innerHTML":_vm._s(term.text)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }